import { Directive, Input, OnChanges, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, Validators } from '@angular/forms';

/** AngularJS ng-maxlength validates the full input without truncating it. */
@Directive({
  selector: '[sfMaxLength]',
  standalone: true,
  providers: [{ provide: NG_VALIDATORS, useExisting: forwardRef(() => MaxLengthValidatorDirective), multi: true }],
})
export class MaxLengthValidatorDirective implements Validator, OnChanges {
  @Input() sfMaxLength: number | string | null | undefined;
  private changed = () => {};

  validate(control: AbstractControl): ValidationErrors | null {
    if (this.sfMaxLength == null || this.sfMaxLength === '') return null;
    return Validators.maxLength(Number(this.sfMaxLength))(control);
  }

  registerOnValidatorChange(fn: () => void): void { this.changed = fn; }
  ngOnChanges(): void { this.changed(); }
}
